module.exports = __webpack_public_path__ + "assets/img/simply-Brand_07.a1d3d9d9.png";